import React from 'react';
import { createRoot } from 'react-dom/client';

import { AppProvider } from 'context';
import App from './App';
import './style.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <AppProvider>
      <App />
     </AppProvider>
  </React.StrictMode>
);